import ProductsContainer from "./components/ProductsList"
import NavbarContainer from "./components/NavbarContainer"
import ShopingCartContextProvider from "./context/ShopingCartContext"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Checkout from "./components/Checkout"
import CountsView from "./components/CountsView"
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.css';
import $ from 'jquery';
import { createPopper } from '@popperjs/core';
import StatsTable from "./components/StatsTable"
import ClosingRecords from './components/ClosingRecords';
import BillingBanner from './components/BillingBanner';



function App() {
  return (
    <div class ="App">
      <ShopingCartContextProvider>
        <BrowserRouter>
            <BillingBanner/>
            <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        color: '#e8d5b7',
        textAlign: 'center',
        padding: '12px 0',
        fontFamily: "'Georgia', 'Times New Roman', serif",
        letterSpacing: '3px',
        fontSize: '1.3rem',
        fontWeight: '600',
        borderBottom: '2px solid #e8d5b7',
        textTransform: 'uppercase',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
      }}>
        ✦ Moons Don Matías ✦
      </div>
      <NavbarContainer/>
            <Routes>
                <Route exect path="/" element = {<ProductsContainer/>}/>
                <Route exect path = "/cuentas" element = {<CountsView/>}/>
                <Route exect path="/recibo/:carrito" element = {<Checkout/>}/>
                <Route exect path="/cuentas/:date" element = {<StatsTable/>}/>
                <Route path="/cuentas/closings" element={<ClosingRecords />} />
            </Routes>
        </BrowserRouter>
      </ShopingCartContextProvider>
    </div>
  )
}

export default App
